/**
 * MO Event Bus - CustomEvent-based pub/sub
 * Replaces Alpine.js stores for cross-component communication
 */
(function () {
  "use strict";

  window.MO = window.MO || {};

  var _target = document.createElement("div");
  var _listeners = {};

  window.MO.bus = {
    /**
     * Emit a custom event
     * @param {string} event - Event name
     * @param {*} [detail] - Event payload
     */
    emit: function (event, detail) {
      _target.dispatchEvent(
        new CustomEvent(event, { detail: detail })
      );
    },

    /**
     * Listen for a custom event
     * @param {string} event - Event name
     * @param {Function} callback - Handler receiving detail as first arg
     * @returns {Function} Unsubscribe function
     */
    on: function (event, callback) {
      var handler = function (e) {
        callback(e.detail);
      };
      _target.addEventListener(event, handler);

      if (!_listeners[event]) _listeners[event] = [];
      _listeners[event].push({ cb: callback, handler: handler });

      return function () {
        window.MO.bus.off(event, callback);
      };
    },

    /**
     * Remove a listener
     * @param {string} event - Event name
     * @param {Function} callback - Original callback passed to on()
     */
    off: function (event, callback) {
      var list = _listeners[event];
      if (!list) return;
      for (var i = list.length - 1; i >= 0; i--) {
        if (list[i].cb === callback) {
          _target.removeEventListener(event, list[i].handler);
          list.splice(i, 1);
        }
      }
    },

    /**
     * Listen for an event only once
     * @param {string} event - Event name
     * @param {Function} callback - Handler
     */
    once: function (event, callback) {
      var unsub = window.MO.bus.on(event, function (detail) {
        unsub();
        callback(detail);
      });
      return unsub;
    }
  };
})();
